import { singleline } from "@core/foundation/string";
import { z } from "@core/zod";

export const ToolCallConditionSchema = z.object(
  {
    blocking: z.boolean().default(false),
    kind: z.literal("toolCall"),
    regexp: z.regexp(),
  },
  {
    blocking: singleline`
      Whether the memory blocks the call — denied and injected before it runs —
      rather than following it, injected beside its result, as it does unless
      set.
    `,
    kind: "The condition's kind, firing on a tool call.",
    regexp: "The JavaScript regexp the called tool's name must match.",
  },
);
